import { SavingsFundsRequestsListItem } from '@Common/types/bo/b2b/savings_funds_requests';

export const savingsFundsRequestsTranslations = {
  fields: {
    id: 'ID Appel de fonds',
    b2b_company_id: 'ID Entreprise',
    number_of_eligible_employees: "Nombre d'adhérent éligible",
    date: 'Date',
    total_gross_amount: 'Montant brut total',
    total_net_amount: 'Montnant net total à régler',
    currency: 'Devise',
    created_at: 'Créé à',
    updated_at: 'Mis à jour à',
    status: 'Statut',
    type: 'Type',
    recon_status: 'Statut de rapprochement',
  } satisfies Record<keyof SavingsFundsRequestsListItem, string>,
  actions: {
    edit: {
      success: 'Action envoyée',
      failure: "Erreur lors de l'envoi: %{error}",
      labels: {
        paid: 'Marqué comme payé',
        completed: 'Marqué comme complété',
      },
    },
  },
};
